import { useState } from 'react'
import { Link } from 'react-router-dom'
import { EnrollmentModal } from '../components/EnrollmentModal'

export function Landing() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [enrollmentModalOpen, setEnrollmentModalOpen] = useState(false)

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-xl sm:text-2xl font-bold text-blue-600">EMR</h1>
            </div>
            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
              <a href="#features" className="text-gray-700 hover:text-blue-600 transition text-sm lg:text-base">Features</a>
              <a href="#benefits" className="text-gray-700 hover:text-blue-600 transition text-sm lg:text-base">Benefits</a>
              <a href="#solutions" className="text-gray-700 hover:text-blue-600 transition text-sm lg:text-base">Solutions</a>
              <Link to="/login" className="text-gray-700 hover:text-blue-600 transition text-sm lg:text-base">Sign In</Link>
              <button
                onClick={() => setEnrollmentModalOpen(true)}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition text-sm lg:text-base"
              >
                Get Started
              </button>
            </div>
            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
              aria-label="Toggle menu"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {mobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden border-t border-gray-200 py-4 space-y-3">
              <a
                href="#features"
                onClick={() => setMobileMenuOpen(false)}
                className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md"
              >
                Features
              </a>
              <a
                href="#benefits"
                onClick={() => setMobileMenuOpen(false)}
                className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md"
              >
                Benefits
              </a>
              <a
                href="#solutions"
                onClick={() => setMobileMenuOpen(false)}
                className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md"
              >
                Solutions
              </a>
              <Link
                to="/login"
                onClick={() => setMobileMenuOpen(false)}
                className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md"
              >
                Sign In
              </Link>
              <button
                onClick={() => {
                  setMobileMenuOpen(false)
                  setEnrollmentModalOpen(true)
                }}
                className="w-full px-3 py-2 text-base font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md text-center"
              >
                Get Started
              </button>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-50 via-white to-blue-50 py-12 sm:py-16 md:py-20 lg:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
              The EMR That Actually
              <span className="text-blue-600 block sm:inline"> Saves You Time</span>
            </h1>
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-600 mb-6 max-w-3xl mx-auto px-2">
              Reduce administrative burden by 50%. Built for modern healthcare with seamless billing,
              intelligent forms, and true interoperability. No data lock-in. No vendor switching fees.
            </p>
            {/* Region Badge */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3 mb-8 px-4">
              <span className="text-xs sm:text-sm text-gray-500 mb-2 sm:mb-0">Available in:</span>
              <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3">
                <span className="inline-flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 bg-white/80 backdrop-blur-sm border border-gray-200 rounded-full text-xs font-medium text-gray-700 touch-manipulation">
                  <span className="text-sm sm:text-base">🇨🇦</span> <span className="hidden xs:inline">Canada</span><span className="xs:hidden">CA</span>
                </span>
                <span className="inline-flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 bg-white/80 backdrop-blur-sm border border-gray-200 rounded-full text-xs font-medium text-gray-700 touch-manipulation">
                  <span className="text-sm sm:text-base">🇺🇸</span> <span className="hidden xs:inline">North America</span><span className="xs:hidden">NA</span>
                </span>
                <span className="inline-flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 bg-white/80 backdrop-blur-sm border border-gray-200 rounded-full text-xs font-medium text-gray-700 touch-manipulation">
                  <span className="text-sm sm:text-base">🇳🇬</span> <span className="hidden xs:inline">Nigeria</span><span className="xs:hidden">NG</span>
                </span>
                <span className="inline-flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 bg-white/80 backdrop-blur-sm border border-gray-200 rounded-full text-xs font-medium text-gray-700 touch-manipulation">
                  <span className="text-sm sm:text-base">🌍</span> <span className="hidden xs:inline">West Africa</span><span className="xs:hidden">WA</span>
                </span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center px-4">
              <button
                onClick={() => setEnrollmentModalOpen(true)}
                className="bg-blue-600 text-white px-6 sm:px-8 py-3.5 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-blue-700 active:bg-blue-800 transition shadow-lg hover:shadow-xl touch-manipulation min-h-[44px] flex items-center justify-center"
              >
                Start Free Trial
              </button>
              <a
                href="#demo"
                className="bg-white text-blue-600 px-6 sm:px-8 py-3.5 sm:py-4 rounded-lg text-base sm:text-lg font-semibold border-2 border-blue-600 hover:bg-blue-50 active:bg-blue-100 transition touch-manipulation min-h-[44px] flex items-center justify-center"
              >
                Watch Demo
              </a>
            </div>
            <p className="mt-4 sm:mt-6 text-xs sm:text-sm text-gray-500 px-4">No credit card required • 30-day free trial • Cancel anytime</p>
          </div>
        </div>
      </section>

      {/* Global Reach Section - Subtle */}
      <section className="py-8 sm:py-12 bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-8 text-center md:text-left">
            <div className="flex-1">
              <p className="text-xs sm:text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">Multi-Regional Platform</p>
              <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                Agile architecture built for diverse healthcare systems. Deployed across Canada, North America,
                Nigeria, and West Africa with region-specific compliance and features.
              </p>
            </div>
            <div className="flex items-center gap-4 sm:gap-6 flex-wrap justify-center">
              <div className="text-center">
                <div className="text-2xl mb-1">🇨🇦</div>
                <p className="text-xs text-gray-600 font-medium">Canada</p>
              </div>
              <div className="text-center">
                <div className="text-2xl mb-1">🇺🇸</div>
                <p className="text-xs text-gray-600 font-medium">North America</p>
              </div>
              <div className="text-center">
                <div className="text-2xl mb-1">🇳🇬</div>
                <p className="text-xs text-gray-600 font-medium">Nigeria</p>
              </div>
              <div className="text-center">
                <div className="text-2xl mb-1">🌍</div>
                <p className="text-xs text-gray-600 font-medium">West Africa</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pain Points Section */}
      <section className="py-12 sm:py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
              Tired of EMR Headaches?
            </h2>
            <p className="text-lg sm:text-xl text-gray-600 px-2">We solve the problems that keep you up at night</p>
          </div>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="text-red-500 text-4xl mb-4">🔒</div>
              <h3 className="text-xl font-semibold mb-2">Data Lock-In</h3>
              <p className="text-gray-600">
                Switch vendors without expensive export fees. Your data, your control.
                Export anytime, no questions asked.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="text-red-500 text-4xl mb-4">📄</div>
              <h3 className="text-xl font-semibold mb-2">Paper Forms Crisis</h3>
              <p className="text-gray-600">
                18.5 million hours wasted annually on paper forms. Our AI-powered system
                auto-generates and submits forms electronically.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="text-red-500 text-4xl mb-4">🔀</div>
              <h3 className="text-xl font-semibold mb-2">Fragmented Systems</h3>
              <p className="text-gray-600">
                Multiple EMRs creating patient safety risks? Our real-time sync makes
                all systems work together seamlessly.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-12 sm:py-16 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-12 md:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
              Built for Modern Healthcare
            </h2>
            <p className="text-lg sm:text-xl text-gray-600 px-2">Everything you need, nothing you don't</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
            <div className="p-6 border border-gray-200 rounded-lg hover:shadow-lg transition">
              <div className="text-blue-600 text-3xl mb-4">🏥</div>
              <h3 className="text-xl font-semibold mb-2">ICD-10-CA & SNOMED CT</h3>
              <p className="text-gray-600">
                Full support for ICD-10-CA diagnosis coding, SNOMED CT Canada terminology,
                and regional coding standards for accurate clinical documentation.
              </p>
            </div>
            <div className="p-6 border border-gray-200 rounded-lg hover:shadow-lg transition">
              <div className="text-blue-600 text-3xl mb-4">📝</div>
              <h3 className="text-xl font-semibold mb-2">Clinical Documentation</h3>
              <p className="text-gray-600">
                Comprehensive clinical notes, templates, vital signs tracking, and
                structured documentation with evidence-based protocols.
              </p>
            </div>
            <div className="p-6 border border-gray-200 rounded-lg hover:shadow-lg transition">
              <div className="text-blue-600 text-3xl mb-4">💳</div>
              <h3 className="text-xl font-semibold mb-2">OHIP Billing Integration</h3>
              <p className="text-gray-600">
                Direct OHIP billing with real-time claim submission, fee schedule lookup,
                and automatic remittance processing.
              </p>
            </div>
            <div className="p-6 border border-gray-200 rounded-lg hover:shadow-lg transition">
              <div className="text-blue-600 text-3xl mb-4">🆔</div>
              <h3 className="text-xl font-semibold mb-2">Health Card Validation</h3>
              <p className="text-gray-600">
                Multi-provincial health card validation (ON, BC, AB, QC) with real-time
                eligibility checking.
              </p>
            </div>
            <div className="p-6 border border-gray-200 rounded-lg hover:shadow-lg transition">
              <div className="text-blue-600 text-3xl mb-4">📋</div>
              <h3 className="text-xl font-semibold mb-2">SADIE Forms Integration</h3>
              <p className="text-gray-600">
                Electronic Special Authorization forms with auto-completion, validation,
                and real-time status tracking.
              </p>
            </div>
            <div className="p-6 border border-gray-200 rounded-lg hover:shadow-lg transition">
              <div className="text-blue-600 text-3xl mb-4">🔬</div>
              <h3 className="text-xl font-semibold mb-2">Lab & Diagnostic Integration</h3>
              <p className="text-gray-600">
                Connect with lab systems, imaging centers, and diagnostic equipment.
                Receive results directly in patient records.
              </p>
            </div>
            <div className="p-6 border border-gray-200 rounded-lg hover:shadow-lg transition">
              <div className="text-blue-600 text-3xl mb-4">💊</div>
              <h3 className="text-xl font-semibold mb-2">E-Prescribing</h3>
              <p className="text-gray-600">
                Electronic prescription management with drug interaction checking,
                formulary compliance, and pharmacy network integration.
              </p>
            </div>
            <div className="p-6 border border-gray-200 rounded-lg hover:shadow-lg transition">
              <div className="text-blue-600 text-3xl mb-4">🤖</div>
              <h3 className="text-xl font-semibold mb-2">AI-Powered Intelligence</h3>
              <p className="text-gray-600">
                Smart form detection, workflow optimization, clinical decision support,
                and diagnostic assistance that learns your patterns.
              </p>
            </div>
            <div className="p-6 border border-gray-200 rounded-lg hover:shadow-lg transition">
              <div className="text-blue-600 text-3xl mb-4">🔗</div>
              <h3 className="text-xl font-semibold mb-2">True Interoperability</h3>
              <p className="text-gray-600">
                HL7 FHIR integration, lab connectivity, and real-time multi-EMR synchronization
                with conflict resolution.
              </p>
            </div>
            <div className="p-6 border border-gray-200 rounded-lg hover:shadow-lg transition">
              <div className="text-blue-600 text-3xl mb-4">📊</div>
              <h3 className="text-xl font-semibold mb-2">Clinical Decision Support</h3>
              <p className="text-gray-600">
                Evidence-based protocols, drug interaction alerts, allergy warnings,
                and risk stratification tools for better patient care.
              </p>
            </div>
            <div className="p-6 border border-gray-200 rounded-lg hover:shadow-lg transition">
              <div className="text-blue-600 text-3xl mb-4">☁️</div>
              <h3 className="text-xl font-semibold mb-2">Offline-First Architecture</h3>
              <p className="text-gray-600">
                Work seamlessly offline with automatic sync when connectivity returns.
                Perfect for rural and remote clinics.
              </p>
            </div>
            <div className="p-6 border border-gray-200 rounded-lg hover:shadow-lg transition">
              <div className="text-blue-600 text-3xl mb-4">🔐</div>
              <h3 className="text-xl font-semibold mb-2">HIPAA/PIPEDA Compliant</h3>
              <p className="text-gray-600">
                Built-in compliance with comprehensive audit logging, encryption,
                and data sovereignty controls.
              </p>
            </div>
            <div className="p-6 border border-gray-200 rounded-lg hover:shadow-lg transition">
              <div className="text-blue-600 text-3xl mb-4">👥</div>
              <h3 className="text-xl font-semibold mb-2">Multi-Tenant & Scalable</h3>
              <p className="text-gray-600">
                Support multiple clinics, regions, and deployment models from a single
                unified platform.
              </p>
            </div>
            <div className="p-6 border border-gray-200 rounded-lg hover:shadow-lg transition">
              <div className="text-blue-600 text-3xl mb-4">⚡</div>
              <h3 className="text-xl font-semibold mb-2">Lightning Fast</h3>
              <p className="text-gray-600">
                Sub-2 second response times, optimized workflows, and intelligent caching
                for instant access.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section id="benefits" className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-blue-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-12 md:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
              Measurable Results
            </h2>
            <p className="text-lg sm:text-xl text-gray-600 px-2">Real impact on your practice</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
            <div className="text-center px-2">
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-600 mb-1 sm:mb-2">50%</div>
              <div className="text-sm sm:text-base md:text-lg font-semibold text-gray-900 mb-1 sm:mb-2">Less Admin Time</div>
              <p className="text-xs sm:text-sm text-gray-600">Reduce documentation and administrative burden</p>
            </div>
            <div className="text-center px-2">
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-600 mb-1 sm:mb-2">15-20</div>
              <div className="text-sm sm:text-base md:text-lg font-semibold text-gray-900 mb-1 sm:mb-2">Minutes Saved</div>
              <p className="text-xs sm:text-sm text-gray-600">Per patient encounter on average</p>
            </div>
            <div className="text-center px-2">
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-600 mb-1 sm:mb-2">99.999%</div>
              <div className="text-sm sm:text-base md:text-lg font-semibold text-gray-900 mb-1 sm:mb-2">Uptime</div>
              <p className="text-xs sm:text-sm text-gray-600">Reliable, always-available system</p>
            </div>
            <div className="text-center px-2">
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-600 mb-1 sm:mb-2">80%</div>
              <div className="text-sm sm:text-base md:text-lg font-semibold text-gray-900 mb-1 sm:mb-2">Faster Forms</div>
              <p className="text-xs sm:text-sm text-gray-600">AI-powered form completion</p>
            </div>
          </div>
        </div>
      </section>

      {/* Solutions Section */}
      <section id="solutions" className="py-12 sm:py-16 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-12 md:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
              Solutions for Every Practice
            </h2>
            <p className="text-lg sm:text-xl text-gray-600 px-2">Flexible deployment options</p>
          </div>
          <div className="grid sm:grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
            <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-lg border-2 border-blue-200">
              <h3 className="text-2xl font-bold mb-4">Cloud EMR</h3>
              <p className="text-gray-600 mb-6">
                Full-featured cloud deployment for urban clinics with reliable internet.
                Real-time sync, automatic backups, and seamless updates.
              </p>
              <ul className="space-y-2 mb-6">
                <li className="flex items-center text-gray-700">
                  <span className="text-green-500 mr-2">✓</span>
                  Unlimited storage
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="text-green-500 mr-2">✓</span>
                  Automatic updates
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="text-green-500 mr-2">✓</span>
                  24/7 support
                </li>
              </ul>
            </div>
            <div className="bg-gradient-to-br from-green-50 to-white p-8 rounded-lg border-2 border-green-200">
              <h3 className="text-2xl font-bold mb-4">Offline-First</h3>
              <p className="text-gray-600 mb-6">
                Perfect for rural and remote clinics. Works completely offline with
                intelligent sync when connectivity returns.
              </p>
              <ul className="space-y-2 mb-6">
                <li className="flex items-center text-gray-700">
                  <span className="text-green-500 mr-2">✓</span>
                  100% offline capable
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="text-green-500 mr-2">✓</span>
                  Conflict resolution
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="text-green-500 mr-2">✓</span>
                  Low bandwidth sync
                </li>
              </ul>
            </div>
            <div className="bg-gradient-to-br from-purple-50 to-white p-8 rounded-lg border-2 border-purple-200">
              <h3 className="text-2xl font-bold mb-4">Portable EMR</h3>
              <p className="text-gray-600 mb-6">
                Raspberry Pi-based portable solution for ultra-remote areas.
                Battery-powered, Wi-Fi enabled, under $100 hardware cost.
              </p>
              <ul className="space-y-2 mb-6">
                <li className="flex items-center text-gray-700">
                  <span className="text-green-500 mr-2">✓</span>
                  Self-contained system
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="text-green-500 mr-2">✓</span>
                  Solar/battery powered
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="text-green-500 mr-2">✓</span>
                  Multi-language support
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-r from-blue-600 to-blue-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 sm:mb-6 px-2">
            Ready to Transform Your Practice?
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-blue-100 mb-6 sm:mb-8 px-2">
            Join healthcare providers who've reduced admin time by 50% and improved patient care.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center px-2">
            <button
              onClick={() => setEnrollmentModalOpen(true)}
              className="bg-white text-blue-600 px-6 sm:px-8 py-3.5 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-gray-100 active:bg-gray-200 transition shadow-lg touch-manipulation min-h-[44px] flex items-center justify-center"
            >
              Start Free Trial
            </button>
            <a
              href="#contact"
              className="bg-transparent text-white px-6 sm:px-8 py-3.5 sm:py-4 rounded-lg text-base sm:text-lg font-semibold border-2 border-white hover:bg-white hover:text-blue-600 active:bg-white/90 transition touch-manipulation min-h-[44px] flex items-center justify-center"
            >
              Schedule Demo
            </a>
          </div>
          <p className="mt-4 sm:mt-6 text-blue-100 text-xs sm:text-sm px-2">
            No credit card required • 30-day free trial • Setup in minutes
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-8 sm:py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
            <div className="col-span-2 sm:col-span-1">
              <h3 className="text-white text-lg sm:text-xl font-bold mb-3 sm:mb-4">EMR</h3>
              <p className="text-xs sm:text-sm leading-relaxed">
                Modern Electronic Medical Records built for healthcare providers across Canada,
                North America, Nigeria, and West Africa.
              </p>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-3 sm:mb-4 text-sm sm:text-base">Product</h4>
              <ul className="space-y-1.5 sm:space-y-2 text-xs sm:text-sm">
                <li><a href="#features" className="hover:text-white transition touch-manipulation block py-1">Features</a></li>
                <li><a href="#solutions" className="hover:text-white transition touch-manipulation block py-1">Solutions</a></li>
                <li><a href="#pricing" className="hover:text-white transition touch-manipulation block py-1">Pricing</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-3 sm:mb-4 text-sm sm:text-base">Regions</h4>
              <ul className="space-y-1.5 sm:space-y-2 text-xs sm:text-sm">
                <li className="flex items-center gap-2">
                  <span>🇨🇦</span>
                  <Link to="/regions/canada" className="hover:text-white transition touch-manipulation block py-1">Canada</Link>
                </li>
                <li className="flex items-center gap-2">
                  <span>🇺🇸</span>
                  <Link to="/regions/north-america" className="hover:text-white transition touch-manipulation block py-1">North America</Link>
                </li>
                <li className="flex items-center gap-2">
                  <span>🇳🇬</span>
                  <Link to="/regions/nigeria" className="hover:text-white transition touch-manipulation block py-1">Nigeria</Link>
                </li>
                <li className="flex items-center gap-2">
                  <span>🌍</span>
                  <Link to="/regions/west-africa" className="hover:text-white transition touch-manipulation block py-1">West Africa</Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-3 sm:mb-4 text-sm sm:text-base">Legal</h4>
              <ul className="space-y-1.5 sm:space-y-2 text-xs sm:text-sm">
                <li><Link to="/privacy" className="hover:text-white transition touch-manipulation block py-1">Privacy</Link></li>
                <li><Link to="/terms" className="hover:text-white transition touch-manipulation block py-1">Terms</Link></li>
                <li><Link to="/compliance" className="hover:text-white transition touch-manipulation block py-1">Compliance</Link></li>
              </ul>
            </div>
          </div>
          <div className="mt-6 sm:mt-8 pt-6 sm:pt-8 border-t border-gray-800 text-center text-xs sm:text-sm px-4">
            <p>&copy; {new Date().getFullYear()} EMR System. All rights reserved. HIPAA/PIPEDA Compliant.</p>
          </div>
        </div>
      </footer>

      {/* Enrollment Modal */}
      <EnrollmentModal
        isOpen={enrollmentModalOpen}
        onClose={() => setEnrollmentModalOpen(false)}
      />
    </div>
  )
}

